import { observer } from 'mobx-react-lite'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export default observer(function CampaignInfSidebarNavLinks({ text, link, active }) {
  const navigate = useNavigate()
  const navigateTo = () => navigate(link)

  return (
    <button
      className={`flex py-2 items-center px-2 ${active && 'border-b-2 border-b-rb-green'}`}
      onClick={() => {
        navigateTo()
      }}
    >
      <p className={`ml-1 ${active && 'text-rb-green'}`}>{text}</p>
    </button>
  )
})
